import Grid from '@mui/material/Grid';
import Layout from '../../../componentsv2/Layout';
import Skeleton from '../../../componentsv2/Skeleton';

export default function InvoicesListSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={12}>
          <Skeleton width="100%" height={200} />
        </Grid>
      </Grid>
    </Layout>
  );
}
